export default "__VITE_ASSET__BSIeDOWy__"